import { NavLink } from "react-router-dom";
import styles from "./SubNav.module.css";

// A horizontal pill-tab bar of related sub-pages — used on /about,
// /lineup, /participate to surface the page's children as a section
// of its own. On mobile it scrolls horizontally so it never wraps.
export default function SubNav({ items }) {
  return (
    <nav className={styles.nav} aria-label="Section">
      <ul className={styles.list}>
        {items.map((item) => (
          <li key={item.path}>
            <NavLink
              to={item.path}
              end={item.end}
              className={({ isActive }) =>
                [styles.tab, isActive ? styles.active : ""].join(" ")
              }
            >
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
